function setQty() {
	var heightElm = document.getElementById('ap-height'),
	widthElm = document.getElementById('ap-width'),
	aQtyElm = document.getElementById('ap-quantity'),
	qtyElm = document.getElementById('Quantity');

	if(productInfo.minArea > Math.ceil(parseFloat(widthElm.value) / 10 * parseFloat(heightElm.value) / 10)) {
		qtyElm.value = productInfo.minArea * aQtyElm.value;
	} else {
		qtyElm.value = Math.ceil(parseFloat(widthElm.value) / 10 * parseFloat(heightElm.value) / 10 * parseFloat(aQtyElm.value));
	}
}

function updatePrice() {
	$('#Quantity, .single-option-selector').trigger('change');
}

$('#ap-height, #ap-width, #ap-quantity').on('input propertychange', function() {
	setQty();
	updatePrice();
});

$('#ap-height, #ap-width, #ap-quantity').change(function() {
	setQty();
	updatePrice();
});

$('#ap-height, #ap-width, #ap-quantity').on('input', function() {
	setQty();
	updatePrice();
});

setQty();
updatePrice();